<template lang="pug">
  .project-group-keywords
    h5(
      v-if="keywords"
    )
      a-tag.mr-2(
        v-for="keyword in keywords"
        :key="keyword"
        @click="setProjectSearchTextWith(keyword)"
        color="blue"
        v-html="keyword"
      )
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    keywords: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    ...mapMutations([
      'setProjectSearchText',
    ]),
    setProjectSearchTextWith(keyword) {
      this.setProjectSearchText(keyword.trim());
    },
  },
};
</script>
